module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2T6Fb"))).then(() => parcelRequire('1iHdE'));